/* eslint-disable react/require-default-props */
import React from 'react';
/**
 * PopupActionList
 * Semantic list wrapper for full-width action rows (`Button` items) inside a popup.
 * Each child is rendered inside an `<li>`; use with `Popup.Section`.
 * @version 1.0.0
 * @since 2026-03-27
 */
export function PopupActionList({ children, className = '', padded = false }) {
    const listClass = ['qmb-ui-popup__action-list', padded ? 'qmb-ui-popup__action-list--padded' : '', className]
        .filter(Boolean)
        .join(' ');
    return (React.createElement("ul", { className: listClass, role: "presentation" }, React.Children.map(children, (child, index) => child != null && child !== false ? React.createElement("li", { key: getChildKey(child, index) }, child) : null)));
}
function getChildKey(child, index) {
    if (React.isValidElement(child) && child.key != null) {
        return child.key;
    }
    return index;
}
PopupActionList.displayName = 'PopupActionList';
